import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignConversation } from '@/api/conversations';
import { queryKeys } from '@/lib/queryKeys';

/**
 * Hook to assign or unassign a conversation to an operator
 *
 * @param conversationId - The conversation to assign
 * @returns Mutation for assigning (pass operator_id or null to unassign)
 */
export function useAssignConversation(conversationId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (operatorId: string | null) =>
      assignConversation({
        conversation_id: conversationId,
        operator_id: operatorId,
      }),
    onSuccess: () => {
      // Refresh conversation metadata (includes assigned_operator_id)
      queryClient.invalidateQueries({
        queryKey: queryKeys.messages.conversation(conversationId),
      });
      // Update inbox list to reflect assignment change
      // Use refetchType: 'active' to only refetch visible queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.conversations.all,
        refetchType: 'active',
      });
    },
  });
}
